import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from 'react-router';
import type { LinksFunction } from 'react-router';
import { KeycloakAuthProvider } from './auth/KeycloakAuthProvider';
import { QueryProvider } from './providers/QueryProvider';
import { keycloakConfig } from './config/keycloak.config';
import { Layout as AppLayout } from './components/Layout';

// Tailwind CSS deaktiviert - verwenden Bootstrap 3
// import './tailwind.css';

export const links: LinksFunction = () => [
  // Bootstrap 3 CSS
  { rel: 'stylesheet', href: '/bootstrap-cus.min.css' },
  // Font Awesome
  { rel: 'stylesheet', href: '/font-awesome.css' },
  // Custom KBW CSS
  { rel: 'stylesheet', href: '/bundle.css' },
  { rel: 'stylesheet', href: '/dynamicelement.css' },
  { rel: 'stylesheet', href: '/seminare.css' },
  { rel: 'stylesheet', href: '/layout.css' },
  // DataGrid CSS (für moderne Komponenten)
  { rel: 'stylesheet', href: '/datagrid.css' },
  // Tiptap Editor CSS
  { rel: 'stylesheet', href: '/tiptap.css' },
  // Fonts
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous',
  },
  {
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
  },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="de">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
        {/* Bootstrap 3 JavaScript Dependencies */}
        <script src="/scripts/jquery-3.3.1.min.js"></script>
        <script src="/scripts/bootstrap.min.js"></script>
      </body>
    </html>
  );
}

export default function App() {
  return (
    <QueryProvider>
      <KeycloakAuthProvider config={keycloakConfig}>
        <AppLayout>
          <Outlet />
        </AppLayout>
      </KeycloakAuthProvider>
    </QueryProvider>
  );
}
